import { UserGroup } from '@/models/user.ts';

import type { CognitoTokenPayload } from '@/schemas/auth-schemas.ts';

interface UserProperties {
    isAdmin: boolean;
    userEmail: string;
    userGroups: string[];
    userScopes: string[];
    userInstanceIds: string[];
    userCustomerIds: string[];
    userLocationIds: string[];
    userPracticeIds: string[];
    userMapPractitionerId: string;
    pictureUrl?: string;
    isFancyCheckinRendered: boolean;
}

export const deriveUserProperties = (data: CognitoTokenPayload): UserProperties => {
    const groups = data['cognito:groups'] ?? [];
    const isAdmin = groups.includes(UserGroup.ADMIN);

    return {
        isAdmin: isAdmin,
        userEmail: data.email,
        userGroups: groups,
        userScopes: data['custom:scopes']?.split(',') ?? [],
        userInstanceIds: data['custom:instance_ids']?.split(',') ?? [],
        userCustomerIds: data['custom:customer_ids']?.split(',') ?? [],
        userLocationIds: data['custom:location_ids']?.split(',') ?? [],
        userPracticeIds: data['custom:practice_ids']?.split(',') ?? [],
        userMapPractitionerId: data['custom:map_practitioner_id'] ?? '',
        pictureUrl: data.picture,
        isFancyCheckinRendered:
            isAdmin ||
            groups.includes(UserGroup.DEV_INTERNAL_ENGINEERS) ||
            groups.includes(UserGroup.PROD_INTERNAL_ENGINEERS),
    };
};
